import { UserInfoActionsEnum } from '../enums/UserInfoActionsEnum';
import { UserInfoStatusesEnum } from '../enums/UserInfoStatusesEnum';
import { IUserInfoState } from '../interfaces/IUserInfoState';
import { UserInfoAction } from '../types/UserInfoAction';

const prosecutorOrganizationsInitialState: IUserInfoState['prosecutorOrganizations'] = {
  status: UserInfoStatusesEnum.IDLE,
  data: [],
  districtId: undefined,
  searchQuery: undefined,
  searchOgrn: undefined,
  pageCount: 0,
  totalCount: 0,
  page: '0',
  parentId: undefined,
};

const initialState: IUserInfoState = {
  isReceiveUserOrg: false,
  knoOrganisations: [],
  organisationsSearchQuery: '',
  organisationsSearchCriteria: 'name',
  organisationsPageCount: 0,
  organisationsTotalCount: 0,
  organisationsPage: '0',
  prosecutorOrganizations: prosecutorOrganizationsInitialState,
  organisationsParentId: '',
  organisationsAdminLevelCode: undefined,
  highlightedSelectedOrganisations: [],
  prosecutorOrganisationByKno: [],
};

export function userInfoReducer(state: IUserInfoState = initialState, action: UserInfoAction) {
  switch (action.type) {
    case UserInfoActionsEnum.USER_INFO_RESET: {
      return initialState;
    }

    case UserInfoActionsEnum.SET_IS_RECEIVE_USER_ORG: {
      return { ...state, isReceiveUserOrg: true };
    }
    case UserInfoActionsEnum.USER_INFO_SET_ORGANISATIONS: {
      const { knoOrganisations, organisationsPage, organisationsPageCount, organisationsTotalCount } = action.payload;
      const newState: IUserInfoState = {
        ...state,
        knoOrganisations,
        organisationsPage,
        organisationsPageCount,
        organisationsTotalCount,
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_SET_ORGANIZATIONS_SEARCH_QUERY: {
      const newState: IUserInfoState = {
        ...state,
        organisationsSearchQuery: action.payload.organisationsSearchQuery,
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_SET_ORGANIZATIONS_PARENT_ID: {
      const newState: IUserInfoState = {
        ...state,
        organisationsParentId: action.payload.organisationsParentId,
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_SET_ORGANIZATIONS_ADMIN_LEVEL_CODE: {
      const newState: IUserInfoState = {
        ...state,
        organisationsAdminLevelCode: action.payload.organisationsAdminLevelCode,
      };

      return newState;
    }

    case UserInfoActionsEnum.USER_INFO_SET_ORGANIZATIONS_SEARCH_CRITERIA: {
      const newState: IUserInfoState = {
        ...state,
        organisationsSearchCriteria: action.payload.value ? 'ogrn' : 'name',
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_KNO_ORGANIZATIONS_RESET: {
      const newState: IUserInfoState = {
        ...state,
        organisationsAdminLevelCode: initialState.organisationsAdminLevelCode,
        organisationsParentId: initialState.organisationsParentId,
        organisationsPage: initialState.organisationsPage,
        organisationsSearchQuery: initialState.organisationsSearchQuery,
        organisationsPageCount: initialState.organisationsPageCount,
        organisationsTotalCount: initialState.organisationsTotalCount,
        knoOrganisations: initialState.knoOrganisations,
        highlightedSelectedOrganisations: initialState.highlightedSelectedOrganisations,
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_REQUEST: {
      return {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          status: UserInfoStatusesEnum.LOADING,
        },
      };
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_SUCCESS: {
      const { list, page, pageCount, totalCount } = action.payload.data;

      return {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          data: list,
          status: UserInfoStatusesEnum.SUCCEEDED,
          page: page.toString(),
          pageCount,
          totalCount,
        },
      };
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_FAILURE: {
      return {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          status: UserInfoStatusesEnum.FAILED,
        },
      };
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_REQUEST: {
      return {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          status: UserInfoStatusesEnum.LOADING,
        },
      };
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_SUCCESS: {
      const { list, page, pageCount, totalCount } = action.payload.data;

      return {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          data: [...state.prosecutorOrganizations.data, ...list],
          status: UserInfoStatusesEnum.SUCCEEDED,
          page: page.toString(),
          pageCount,
          totalCount,
        },
      };
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_FAILURE: {
      return {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          status: UserInfoStatusesEnum.FAILED,
        },
      };
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_DISTRICT_ID: {
      const newState: IUserInfoState = {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          districtId: action.payload.districtId,
        },
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_SEARCH_QUERY: {
      const newState: IUserInfoState = {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          searchQuery: action.payload.searchQuery,
        },
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_PARENT_ID: {
      const newState: IUserInfoState = {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          parentId: action.payload.parentId,
        },
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_SEARCH_OGRN: {
      const newState: IUserInfoState = {
        ...state,
        prosecutorOrganizations: {
          ...state.prosecutorOrganizations,
          searchOgrn: action.payload.searchOgrn,
        },
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_RESET: {
      const newState: IUserInfoState = {
        ...state,
        prosecutorOrganizations: prosecutorOrganizationsInitialState,
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_SET_CURRENT_FUNCTIONS_MODAL_ID: {
      const { currentFunctionsModalId } = action.payload;
      const newState: IUserInfoState = {
        ...state,
        currentFunctionsModalId,
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_SET_IS_ERVK: {
      const newState: IUserInfoState = {
        ...state,
        isErvk: action.payload.value,
      };

      return newState;
    }
    case UserInfoActionsEnum.USER_INFO_SET_HIGHLIGHTED_SELECTED_ORGANISATIONS: {
      return {
        ...state,
        highlightedSelectedOrganisations: action.payload.organisations,
      };
    }

    case UserInfoActionsEnum.USER_INFO_PROSECUTOR_BY_ORGANIZATIONS_GET_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        prosecutorOrganisationByKno: data,
      };
    }

    default:
      return state;
  }
}
